var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M5 .864 5.876 0l10.909 11.067L5.874 22l-.871-.87 10.049-10.068z"}));
}

ArrowRight.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
